"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determineFlowLink = exports.default = void 0;
var _constants = require("@nerdwallet/marketplace/constants");
var _appConfig = _interopRequireDefault(require("@nerdwallet/app-config"));
var _logging = require("@nerdwallet/logging");
var logger = (0, _logging.getLogger)('MarketplaceApplyNow');
var _default = function _default(_ref) {
  var text = _ref.text,
    useUpdatedInsuranceCTAs = _ref.useUpdatedInsuranceCTAs;
  if (useUpdatedInsuranceCTAs) {
    return {
      vertical: 'Insurance',
      text: text !== null && text !== void 0 ? text : 'Get a Quote'
    };
  }
  return {
    vertical: 'Insurance',
    text: text !== null && text !== void 0 ? text : 'Apply Now'
  };
};
exports.default = _default;
var determineFlowLink = function determineFlowLink(subProductType) {
  if (subProductType === _constants.INSURANCE_SUB_PRODUCT_TYPES.AUTO || subProductType === _constants.INSURANCE_SUB_PRODUCT_TYPES.CAR || subProductType === _constants.INSURANCE_SUB_PRODUCT_TYPES.CLASSIC_CAR) {
    return "".concat(_appConfig.default === null || _appConfig.default === void 0 ? void 0 : _appConfig.default.SITE_BASE_URL, "/insurance/match");
  }
  if (subProductType === _constants.INSURANCE_SUB_PRODUCT_TYPES.HOME || subProductType === _constants.INSURANCE_SUB_PRODUCT_TYPES.HOMEOWNERS_PROPERTY || subProductType === _constants.INSURANCE_SUB_PRODUCT_TYPES.RENTERS || subProductType === _constants.INSURANCE_SUB_PRODUCT_TYPES.RENTERS_SUB) {
    return "".concat(_appConfig.default === null || _appConfig.default === void 0 ? void 0 : _appConfig.default.SITE_BASE_URL, "/home-insurance/match");
  }
  if (subProductType === _constants.INSURANCE_SUB_PRODUCT_TYPES.LIFE || subProductType === _constants.INSURANCE_SUB_PRODUCT_TYPES.LIFE_SUB || subProductType === _constants.INSURANCE_SUB_PRODUCT_TYPES.UNIVERSAL_LIFE || subProductType === _constants.INSURANCE_SUB_PRODUCT_TYPES.VARIABLE_LIFE) {
    return "".concat(_appConfig.default === null || _appConfig.default === void 0 ? void 0 : _appConfig.default.SITE_BASE_URL, "/insurance/life/match");
  }
  if (subProductType === _constants.INSURANCE_SUB_PRODUCT_TYPES.TRAVEL) {
    return "".concat(_appConfig.default === null || _appConfig.default === void 0 ? void 0 : _appConfig.default.SITE_BASE_URL, "/insurance/travel/match");
  }
  logger.error('No SubProductType found for Insurance Offer - falling back to review link');
  return null;
};
exports.determineFlowLink = determineFlowLink;